import { getFieldValue } from '../../../brite-viewer/components/benefits/field-utils';

export const productHasIncludedPrograms = (product, includedPrograms) => {
  return !!Object.entries(includedPrograms || {})?.length && product?.Type !== 'hsa_buyup';
};

export const getFieldsAndGroups = (product, layout) => {
  if (!layout?.Sections) {
    return {};
  }
  const fields = layout?.Sections?.reduce((acc, section, sectionIdx) => {
    return section?.Fields?.reduce((acc, field, fieldIdx) => {
      if (field?.State === 'hide') {
        return acc;
      }
      const value = getFieldValue(product, field);
      return {
        ...acc,
        [field?.PropertyChain]: {
          ...field,
          order: sectionIdx * 1000 + fieldIdx,
          value,
        },
      };
    }, acc);
  }, []);

  const fieldKeys = Object.keys(fields).sort((a, b) => b.order - a.order);
  const groups = {};
  let currentGroup = 'main';
  for (const key of fieldKeys) {
    if (fields[key].Type === 'label') {
      currentGroup = fields[key].PropertyChain;
    } else if (key !== 'Cost') {
      if (!(currentGroup in groups)) {
        groups[currentGroup] = [];
      }
      groups[currentGroup].push(key);
    }
  }

  const { main, ...rest } = groups;

  return { fields, groups: rest, detail: main };
};

export const getHasCost = (data) => {
  const idx = data?.layout?.Sections?.findIndex(({ DisplayValue }) => DisplayValue === 'Premiums & Contributions');
  if (idx > -1) {
    const cost = data?.layout?.Sections?.[idx];
    const field = cost?.Fields?.find(({ PropertyChain }) => PropertyChain === 'Cost');
    return field?.State !== 'hide';
  }
  return false;
};

export const getColumns = (data) => {
  const includedPrograms = productHasIncludedPrograms(data.product, data.includedPrograms);
  const hasCustomDetails = !!data.product?.TitleDescriptions?.filter(({ Autogenerated }) => !Autogenerated)?.length;
  const hasConditions =
    data.product?.Type === 'critical_illness' && data.product?.Details?.ConditionPercentages?.length;
  const hasCostSection = getHasCost(data);
  const hasAdditionalGroups = includedPrograms || hasCustomDetails || hasConditions || hasCostSection;
  if (hasAdditionalGroups) {
    return 2;
  }
  return 1;
};
